import { Flex, Icon, Tag, Tooltip } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { FaGoogle, FaLocationArrow, FaMicrosoft, FaPhoneAlt, FaQuestion } from 'react-icons/fa';
import { OptionProps, components } from 'react-select';
import { ILocationOption } from '../useSectionGeneral';

export default function LocationOption(
	props: OptionProps<{ value: ILocationOption; label: string; isDisabled: boolean }>
) {
	return (
		<components.Option
			{...props}
			innerProps={{
				...props.innerProps,
				onClick(e) {
					if (props.isDisabled) {
						return;
					}

					if (props.innerProps?.onClick) {
						props.innerProps?.onClick(e);
					}
				},
			}}
		>
			<OptionInner {...props.data} />
		</components.Option>
	);
}

function OptionInner(props: { label: string; value: ILocationOption; isDisabled: boolean }) {
	const { t } = useTranslation();

	switch (props.value) {
		case 'BOOKER_SELECTION':
			return (
				<Tooltip
					hasArrow
					label={t(
						'This option will add a Location question to the booking page so the booker will be able to select the location.'
					)}
				>
					<Flex justifyContent="flex-start" alignItems="center" aria-disabled={props.isDisabled}>
						<Icon as={FaQuestion} mr="4" /> {props.label}
					</Flex>
				</Tooltip>
			);
		case 'BOOKER_PHONE':
			return (
				<Tooltip
					hasArrow
					placement="right"
					label={t('This option will add a Phone question to the booking page so you can call the booker.')}
				>
					<Flex justifyContent="flex-start" alignItems="center" aria-disabled={props.isDisabled}>
						<Icon as={FaPhoneAlt} mr="4" /> {props.label}
					</Flex>
				</Tooltip>
			);
		case 'FIXED':
			return (
				<Tooltip
					hasArrow
					label={t(
						'This option allows you to specify a custom location like a physical location or your own video conference link.'
					)}
				>
					<Flex justifyContent="flex-start" alignItems="center" aria-disabled={props.isDisabled}>
						<Icon as={FaLocationArrow} mr="4" /> {props.label}
					</Flex>
				</Tooltip>
			);
		case 'GOOGLE_MEET':
			return (
				<Tooltip
					hasArrow
					label={
						props.isDisabled
							? t('To enable this option select a Google calendar as primary calendar.')
							: t('When this option is selected a Google Meet link will be added to the calendar invitation.')
					}
				>
					<Flex justifyContent="flex-start" alignItems="center" aria-disabled={props.isDisabled}>
						<Icon as={FaGoogle} mr="4" /> {props.label}{' '}
						{props.isDisabled ? (
							<Tag size="sm" opacity={0.6} colorScheme="orange" ml="auto">
								{t('No primary calendar selected')}
							</Tag>
						) : null}
					</Flex>
				</Tooltip>
			);
		case 'MS_TEAMS':
			return (
				<Tooltip
					hasArrow
					label={
						props.isDisabled
							? t('To enable this option select a Microsoft calendar as primary calendar.')
							: t('When this option is selected a Microsoft Teams link will be added to the calendar invitation.')
					}
				>
					<Flex justifyContent="flex-start" alignItems="center" aria-disabled={props.isDisabled}>
						<Icon as={FaMicrosoft} mr="4" /> {props.label}{' '}
						{props.isDisabled ? (
							<Tag size="sm" opacity={0.6} colorScheme="orange" ml="auto">
								{t('No primary calendar selected')}
							</Tag>
						) : null}
					</Flex>
				</Tooltip>
			);
	}
}
